import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

export const LIVE_PORTAL_URL = 'https://portal.phantompathvpn.com/';

const ExternalPortalRedirect = () => {
  useEffect(() => {
    window.location.replace(LIVE_PORTAL_URL);
  }, []);

  return (
    <main className="flex min-h-[60vh] items-center justify-center bg-[#050b14] px-4 text-center text-white">
      <Helmet>
        <title>PhantomPath Portal</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href={LIVE_PORTAL_URL} />
      </Helmet>
      <div>
        <p className="mb-3 text-sm text-gray-400">Opening the secure PhantomPath Portal…</p>
        <a className="font-bold text-[#00ffc8] underline" href={LIVE_PORTAL_URL}>
          Continue to PhantomPath Portal
        </a>
      </div>
    </main>
  );
};

export default ExternalPortalRedirect;
